var render, staticRenderFns
import script from "./SurveyPopup.vue?vue&type=script&lang=js&"
export * from "./SurveyPopup.vue?vue&type=script&lang=js&"
import style0 from "./SurveyPopup.vue?vue&type=style&index=0&id=b5832dac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5832dac",
  null
  
)

export default component.exports